// extracted by mini-css-extract-plugin
module.exports = {"cta":"Cta_cta__RbHy4","title":"Cta_title__BmHFx","text":"Cta_text__QrJ8W"};